export default {
  SHOPIFY_BASE_URL: process.env.NEXT_PUBLIC_SHOPIFY_BASE_URL,
  SHOPIFY_API_VERSION: process.env.NEXT_PUBLIC_SHOPIFY_API_VERSION,
  SHOPIFY_ACCESS_TOKEN: process.env.NEXT_PUBLIC_SHOPIFY_ACCESS_TOKEN
};
